/**
 * The staff "pay the whole year now" answer, remembered for one re-enrolment in this browser tab.
 * The server keeps the other answers on this screen, but not this one, so without it a staff family
 * who went to the payment page and came back found it reset to "No" — and the fees with it.
 */
const STAFF_PAY_IN_FULL_KEY = (SessionID) => `reenrolment:staffPayInFull:${SessionID}`;

export const rememberStaffPayInFull = (SessionID, value) => {
  if (!SessionID) return;
  try {
    sessionStorage.setItem(STAFF_PAY_IN_FULL_KEY(SessionID), value);
  } catch {
    // Storage unavailable: the answer is simply asked again.
  }
};

export const recalledStaffPayInFull = (SessionID) => {
  if (!SessionID) return '';
  try {
    const value = sessionStorage.getItem(STAFF_PAY_IN_FULL_KEY(SessionID));
    return value === 'Yes' || value === 'No' ? value : '';
  } catch {
    return '';
  }
};
